import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { environment } from 'src/environments/environment';
import { FiltroBuscaService } from '../service/filtro-busca-service/filtro-busca.service';

export interface TipoObra {
  id: number;
  description: string;
  checked?: boolean;
}

@Component({
  selector: 'app-filtro-tipo-obra',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownToggleDirective],
  templateUrl: './filtro-tipo-obra.component.html',
  styleUrls: ['./filtro-tipo-obra.component.scss'],
})
export class FiltroTipoObraComponent implements OnInit, OnDestroy {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  tiposObra: TipoObra[] = [];
  @Input() tiposSelecionados: number[] = [];
  @Input() disabled: boolean = false;
  @Output() tiposObraChange = new EventEmitter<TipoObra[]>();
  private isInitializing = true;

  private readonly _errorHandleService = inject(ErrorHandleService);
  private subscription = new Subscription();

  constructor(private readonly _filtroBuscaService: FiltroBuscaService) {}

  ngOnInit() {
    this.isInitializing = true;
    this.buscarTiposObra();
  }

  ngOnChanges() {
    if (this.tiposSelecionados && this.tiposObra.length > 0) {
      this.tiposObra.forEach((tipo) => {
        tipo.checked = this.tiposSelecionados.includes(tipo.id);
      });
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  buscarTiposObra() {
    this.subscription.add(
      this._filtroBuscaService.buscarFiltroTiposObras().subscribe({
        next: (res) => {
          if (res.success) {
            if (this.tiposObra.length === 0) {
              const selecionadosSafe = Array.isArray(this.tiposSelecionados)
                ? this.tiposSelecionados
                : [];
              this.tiposObra = res.data.map((item: TipoObra) => ({
                ...item,
                checked: selecionadosSafe.includes(item.id),
              }));

              this.isInitializing = false;
            }
          } else {
            this._errorHandleService.throwConsoleError(res.message);
          }
        },
      })
    );
  }

  onCheckChange(event: Event, option: TipoObra) {
    const checked = (event.target as HTMLInputElement).checked;
    option.checked = checked;
    const selecionados = this.tiposObra.filter((o) => o.checked);
    if (!this.isInitializing) {
      this.tiposObraChange.emit(selecionados);
    }
  }
}
